import { render } from "./BusinessReceiptPaymentModal.vue?vue&type=template&id=28a257c3&scoped=true&ts=true"
import script from "./BusinessReceiptPaymentModal.vue?vue&type=script&lang=ts"
export * from "./BusinessReceiptPaymentModal.vue?vue&type=script&lang=ts"

import "./BusinessReceiptPaymentModal.vue?vue&type=style&index=0&id=28a257c3&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a257c3"]])

export default __exports__